import { useEffect } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';

export function PageTitle({ title }: { title: string }) {
  const { trackPage } = useAnalytics();

  useEffect(() => {
    void trackPage(title);
  }, [title, trackPage]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title}${title ? ' - ' : ''}Sami`;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return null;
}
